import { FinalPrepCheckCtrl } from './final-prep-check.controller';

export const FinalPrepCheckComponent = {
  controller: FinalPrepCheckCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./final-prep-check.html'),
};
